// vim: set ts=2 sts=2 sw=2 et:

import React from "react";
import { connect } from "react-redux";

import { GlobalState } from "../../types/stateTypes";
import { PlatformLiveFeatures } from "../live/platformLiveProfile";
import { PlatformRef } from "../types";
import OperationLayerContainer, { OperatorPresentation } from "./OperationLayerContainer";

interface OwnProps {
  locationSearch: string;
  /** OperatorLiveHost: sigue en vivo mientras el operador está en otra pantalla. */
  presentation?: OperatorPresentation;
}

interface StateProps {
  platformRef: PlatformRef;
  liveFeatures: PlatformLiveFeatures;
}

type Props = OwnProps & StateProps;

const ClassicLiftingLiveContainer = (props: Props) => {
  return (
    <OperationLayerContainer
      platformRef={props.platformRef}
      locationSearch={props.locationSearch}
      classicLiftingWindow={true}
      liveFeatures={props.liveFeatures}
      presentation={props.presentation}
    />
  );
};

const mapStateToProps = (state: GlobalState): StateProps => {
  return {
    platformRef: state.wrpfLive.activeProfile
      ? {
          day: state.wrpfLive.activeProfile.day,
          platformId: state.wrpfLive.activeProfile.platformId,
        }
      : {
          day: state.lifting.day,
          platformId: state.lifting.platform,
        },
    liveFeatures: state.wrpfLive.activeProfile?.features || { judgeVoting: true, spectatorDisplay: true, dmx: false },
  };
};

export default connect(mapStateToProps)(ClassicLiftingLiveContainer);
